import request from "@/config/utils/request";
// 校验是否为应用管理员账户
export function getMcConcBill(data) {
  return request({
    url: "/apis/demo/mc/getMcConcBill",
    method: "post",
    data
  });
}

export function listDemoUserPage(data) {
  return request({
    url: "/apis/demo/demouser/listDemoUserPage",
    method: "POST",
    data
  });
}
export function qryCategoryByCode(data) {
  return request({
    url: "/apis/demo/refer/listMatSubCataTree",
    method: "POST",
    data
  });
}
export function listConSupPage(data) {
  return request({
    url: "/apis/demo/refer/listDemoUserTablePage",
    method: "POST",
    data
  });
}

// 角色中用户
export function saveUserList(data) {
  return request({
    url: "/apis/demo/role/saveUserList", // 新建角色中的成员[{userList autoCode}]
    method: "post",
    timeout: 30 * 1000,
    data
  });
}
// 公用 请求组织机构下的部门及人员（不包含子集单位及其人员）
export function getUnderOrg(obj) {
  return request({
    url: "dev01-smp.iccec.cn/apis/smp/basic/qryOrgTree",
    method: "post",
    data: obj
  });
}

export function searchList(data) {
  return request({
    url: "/apis/demo/refer/listPartyRelationTreePage",
    method: "post",
    data
  });
}

export function listMateriaCata(data) {
  return request({
    url: "/apis/demo/refer/listMatCatery",
    method: "post",
    data
  });
}
export function listMatSubCataTree(data) {
  return request({
    url: "/apis/demo/refer/listMatCateryTree",
    method: "post",
    data
  });
}

// 单树的模糊搜索
export function listPageMaterialByName(data) {
  return request({
    url: "/apis/demo/refer/listPageMaterialByName",
    method: "post",
    data
  });
}

export function searchmatCaterySingleLeftTreeRightTableList(data) {
  return request({
    url: "/apis/demo/refer/listPageMatCateryByName",
    method: "POST",
    data
  });
}
export function searchmatCaterySingleLeftTreeRightTableTree(data) {
  return request({
    url: "/apis/demo/refer/listMatCateryTree",
    method: "POST",
    data
  });
}

export function listDemoUserMultiSelectTablePage(data) {
  return request({
    url: "/apis/demo/refer/listDemoUserTablePage",
    method: "POST",
    data
  });
}
export function listDemoUserSingleSelectTablePage(data) {
  return request({
    url: "/apis/demo/refer/listDemoUserTablePage",
    method: "POST",
    data
  });
}
export function searchpartyRelationSingleSelectTreeList(data) {
  return request({
    url: "/apis/demo/refer/listPartyRelationTreePage",
    method: "POST",
    data
  });
}
export function getUnderpartyRelationSingleSelectTree(data) {
  return request({
    url: "/apis/demo/refer/listUnderPartyRelationTree",
    method: "POST",
    data
  });
}
export function searchpartyRelationMultiSelectTreeList(data) {
  return request({
    url: "/apis/demo/refer/listPartyRelationTreePage",
    method: "POST",
    data
  });
}
export function getUnderpartyRelationMultiSelectTree(data) {
  return request({
    url: "/apis/demo/refer/listUnderPartyRelationTree",
    method: "POST",
    data
  });
}
export function searchmatCateryMultiLeftTreeRightTableList(data) {
  return request({
    url: "/apis/demo/refer/listMatCatery",
    method: "POST",
    data
  });
}
export function searchmatCateryMultiLeftTreeRightTableTree(data) {
  return request({
    url: "/apis/demo/refer/listMatCateryTree",
    method: "POST",
    data
  });
}
